import React, { useState } from 'react';
import {
  ErrorMessage, Field, Form, Formik,
} from 'formik';
import { useDispatch, useSelector } from 'react-redux';
import { toast } from 'react-toastify';
import Cookies from 'js-cookie';
import ValidationSchema from '../../helpers/ValidationSchema';
import Spinner from '../Spinner';
import { passwordReset } from '../../store/actions/user';
import toggleRegisterForm from '../../store/actions/registerFormToggle';

function ForgotPassword() {
  const { forgotSchema } = ValidationSchema();
  const [loading, setLoading] = useState(false);
  const { translations } = useSelector((state) => state.translation);
  const lang = Cookies.get('i18next') || 'en';
  const dispatch = useDispatch();
  const handleSendRecoverCode = async (values) => {
    setLoading(true);
    const { payload } = await dispatch(passwordReset({ email: values.email, lang }));
    if (payload.status !== 'error') {
      toast(payload.message, { type: 'success', autoClose: 3000 });
      dispatch(toggleRegisterForm({ visible: false, type: 'register' }));
    } else {
      toast(payload.message, { type: 'error', autoClose: 3000 });
    }
    setLoading(false);
  };
  return (
    <Formik
      initialValues={{
        email: '',
      }}
      onSubmit={(values, actions) => {
        handleSendRecoverCode(values);
        actions.setSubmitting(false);
      }}
      validationSchema={forgotSchema}
    >
      <Form className="register-form">
        <div className="register-form-group">
          <label className="inputs-label" htmlFor="email">{translations.email_label[lang]}</label>
          <div className="register-form-group_input input-block">
            <Field
              as="input"
              type="text"
              name="email"
              id="email"
              placeholder={translations.email_placeholder[lang]}
            />
          </div>
          <ErrorMessage
            name="email"
            component="p"
            className="authError"
          />
        </div>
        <button type="submit" className="register-form-button">
          {
                        loading ? <Spinner isBtn size={30} />
                          : <p>{translations.send_code[lang]}</p>
                    }
        </button>
      </Form>
    </Formik>
  );
}

export default ForgotPassword;
